<template>

  <div class="p-grid irinox-form">
    <div class="p-col-12 p-lg-5 p-xl-4 p-xxl-4 personal-data">
      <div class="p-d-flex p-jc-between p-ai-center p-mb-2">
        <h3>{{ $t('spareParts.cart.personalData') }}</h3>
      </div>
      <div class="">
        <p>
          <label>{{ $t('userinfo.first_name').toLowerCase() }}</label>
          <span>{{ userdata?.firstName }}</span>
        </p>
        <p>
          <label>{{ $t('userinfo.last_name').toLowerCase() }}</label>
          <span>{{ userdata?.lastName }}</span>
        </p>
        <p>
          <label>{{ $t('company.name').toLowerCase() }}</label>
          <span>{{ company?.name }}</span>
        </p>
        <p>
          <label>{{ $t('company.taxCode').toLowerCase() }}</label>
          <span>{{ company?.taxCode }}</span>
        </p>
        <p>
          <label>{{ $t('company.address').toLowerCase() }}</label>
          <span>{{ company?.address }}</span>
        </p>
        <p>
          <label>{{ $t('company.postalCode').toLowerCase() }}</label>
          <span>{{ company?.postalCode }}</span>
        </p>
        <p>
          <label>{{ $t('company.city').toLowerCase() }}</label>
          <span>{{ company?.city }}</span>
        </p>
        <p>
          <label>{{ $t('company.district').toLowerCase() }}</label>
          <span>{{ company?.district }}</span>
        </p>
        <p>
          <label>{{ $t('company.country').toLowerCase() }}</label>
          <span>{{ company?.country }}</span>
        </p>
      </div>
    </div>
    <div class="p-col-12 p-lg-7 p-xl-8 p-xxl-6 shipping-data">

      <div class="p-d-flex p-jc-between p-ai-center p-mb-2">
        <h3>{{ $t('spareParts.cart.shippingData') }}</h3>
        <Button :label="$t('spareParts.cart.copy_from_personal')" link @click="copy"/>
      </div>
      <div class="">
        <div class="p-fluid p-formgrid p-grid ">
          <div class="p-field p-col-12 p-md-6">
            <label for="name">{{ $t('company.name').toLowerCase() }}</label>
            <InputText id="name" type="text" v-model="shipping.name" :placeholder="$t('company.name_ph')"
              :class="{ 'p-invalid': v$.shipping.name.$invalid && submitted }" />
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="address">{{ $t('company.address').toLowerCase() }}</label>
            <InputText id="address" type="text" v-model="shipping.address" :placeholder="$t('company.address_ph')"
              :class="{ 'p-invalid': v$.shipping.address.$invalid && submitted }"  />
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="district">{{ $t('company.district').toLowerCase() }}</label>
            <InputText id="district" type="text" v-model="shipping.district" :placeholder="$t('company.district_ph')"
              :class="{ 'p-invalid': v$.shipping.district.$invalid && submitted }" />
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="postalCode">{{ $t('company.postalCode').toLowerCase() }}</label>
            <InputText id="postalCode" type="text" v-model="shipping.postalCode"
              :placeholder="$t('company.postalCode_ph')"
              :class="{ 'p-invalid': v$.shipping.postalCode.$invalid && submitted }" />
          </div>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-6">
            <label for="city">{{ $t('company.city').toLowerCase() }}</label>
            <InputText id="city" type="text" v-model="shipping.city" :placeholder="$t('company.city_ph')"
              :class="{ 'p-invalid': v$.shipping.city.$invalid && submitted }"  />
          </div>
          <div class="p-field p-col-12 p-md-6">
            <label for="country">{{ $t('company.country').toLowerCase() }}</label>
            <Dropdown id="country" v-model="shipping.country" :options="countries" optionLabel="name" optionValue="code"
              :placeholder="$t('company.country_ph')" :filter="true"
              :class="{ 'p-invalid': v$.shipping.country.$invalid && submitted }" />
          </div>
        </div>
      </div>


      <div class="p-d-flex p-jc-between p-ai-center p-mt-4 p-mb-2">
        <h3>{{ $t('spareParts.cart.priority') }}</h3>
      </div>
      <div class="p-d-flex" style="gap: 30px;">
        <div class="p-field-checkbox" style="margin: 0;">
          <RadioButton v-model="priority" class="p-mr-2"
            :aria-label="$t('spareParts.cart.priority_standard')" name="priority"
            value="STANDARD" :class="{ 'p-invalid': v$.priority.$invalid && submitted }" />
          <p v-html="$t('spareParts.cart.priority_standard')"></p>
        </div>
        <div class="p-field-checkbox" style="margin: 0;">
          <RadioButton v-model="priority" class="p-mr-2"
            :aria-label="$t('spareParts.cart.priority_urgent')" name="priority"
            value="URGENT" :class="{ 'p-invalid': v$.priority.$invalid && submitted }" />
          <p v-html="$t('spareParts.cart.priority_urgent')"></p>
        </div>
      </div>

      <div class="p-d-flex p-jc-between p-ai-center p-mt-4 p-mb-2">
        <h3>{{ $t('spareParts.cart.orderType') }}</h3>
      </div>
      <div class="p-d-flex p-ai-center" style="gap: 30px;">
        <div class="p-field-checkbox" style="margin: 0;">
          <RadioButton v-model="orderType" class="p-mr-2"
            :aria-label="$t('spareParts.cart.orderType_stock')" name="orderType"
            value="STOCK" :class="{ 'p-invalid': v$.orderType.$invalid && submitted }" />
          <p v-html="$t('spareParts.cart.orderType_stock')"></p>
        </div>
        <div class="p-field-checkbox" style="margin: 0;">
          <RadioButton v-model="orderType" class="p-mr-2"
            :aria-label="$t('spareParts.cart.orderType_serial')" name="orderType"
            value="SERIAL" :class="{ 'p-invalid': v$.orderType.$invalid && submitted }" />
          <p v-html="$t('spareParts.cart.orderType_serial')"></p>
        </div>
        <div class="p-field-checkbox" style="margin: 0;">
          <InputText id="serialNumber" type="text" v-model="serialNumber" :placeholder="$t('spareParts.cart.serialNumber_ph')" />
            <!-- :class="{ 'p-invalid': v$.serialNumber.$invalid && submitted }"  /> -->
        </div>
      </div>

      <div class="totals p-mt-4">
        <div class="p-d-flex p-jc-end p-ai-center p-pr-4">
          <div class="">{{ $t('spareParts.cart.total_price') }}</div>
          <div class="p-text-right" style="width: 180px;">
            {{ totalPrice ? $n(totalPrice, 'money') : '-' }}
            {{ totalPrice ? (cart[0].currency === 'EUR' ? '€ ' : '$ ') : '' }}
          </div>
        </div>
        <div class="p-d-flex p-jc-end p-ai-center p-pr-4">
          <div class="">{{ $t('spareParts.cart.total_quantity') }}</div>
          <div class="p-text-right" style="width: 180px;">
            {{ totalItems }}
          </div>
        </div>
      </div>

      <div class="p-d-flex p-flex-column p-ai-end p-mt-4">
        <div class="disclaimer p-pr-4">{{ $t('spareParts.cart.disclaimer') }}</div>
        <Button :label="$t('spareParts.cart.send_button')" class="p-mt-4 p-mr-4" @click="checkBeforeSend(!v$.$invalid)" /> 
      </div>

    </div>


  </div>

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('spareParts.cart.error_dialog')" :life="5000"
    @update:visible="dialog.error = $event" />

  <IrinoxDialogDark :visible="dialog.success" mode="success" :message="$t('spareParts.cart.success_dialog')" :life="3000"
    @update:visible="dialog.success = $event" />

  <IrinoxDialogDark :visible="dialog.orderConfirm" mode="confirm" 
    :leftB="$t('spareParts.cart.confirm_dialog_cancel')" @click:left-button="dialog.orderConfirm = false" 
    :rightB="$t('spareParts.cart.confirm_dialog_confirm')" @click:right-button="send(!v$.$invalid)" 
    :message="$t('spareParts.cart.confirm_dialog_massage')"
    icon="assets/irinox/icons/faq.svg" />

</template>

<script>
import { mapGetters } from 'vuex';
import IrinoxDialogDark from '../../IrinoxDialogDark.vue';
import AfterSalesService from '../../../service/AfterSalesService';
import AccountService from '../../../service/AccountService';
import CountryService from '../../../service/CountryService';
import { required, requiredIf } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  components: {
    IrinoxDialogDark
  },
  setup: () => ({ v$: useVuelidate() }),
  props: {
    comment: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      company: null,
      userdata: null,
      dialog: {
        error: false,
        success: false,
        orderConfirm: false
      },
      countries: [],
      shipping: {},
      priority: 'STANDARD',
      orderType: 'STOCK',
      serialNumber: null,
      submitted: false,
    }
  },
  computed: {
    ...mapGetters({
      personaltoken: 'userdata/personaltoken',
      role: 'userdata/role',
      cart: 'afterSales/cart'
    }),
    totalPrice() {
      let totalInCents = 0;
      this.cart.forEach(item => {
        if (item.price && item.quantity) {
          // Converti il prezzo in centesimi arrotondando, per evitare problemi di calcolo con virgola mobile (floating point standard IEEE 754)
          totalInCents += Math.round(item.price * 100) * item.quantity;
        }
      });
      return totalInCents / 100;
    },
    totalItems() {
      let total = 0;
      this.cart.forEach(item => {
        if(item.quantity) {
          total += item.quantity;
        }
      });
      return total;
    }
  },
  validations() {
    return {
      shipping: {
        name: {
          required
        },
        country: {
          required
        },
        district: {
          required: requiredIf(function () {
            return this.shipping.country === 'IT'
          })
        },
        city: {
          required
        },
        postalCode: {
          required
        },
        address: {
          required
        },
      },
      priority: {
        required
      },
      orderType: {
        required
      },
      // serialNumber: {
      //   required: requiredIf(function () {
      //     return this.orderType === 'SERIAL'
      //   })
      // },
    }
  },
  created() {
    this.afterSalesService = new AfterSalesService();
    this.accountService = new AccountService();
    this.countryService = new CountryService();
  },
  mounted() {
    this.countryService.getCountries().then((countries) => {
      this.countries = countries;
    });
    this.getUserData();
  },
  methods: {
    getUserData() {
      this.accountService.getUserinfo(this.personaltoken)
        .then(userinfo => {
          this.userdata = userinfo;
          this.accountService.getCompany(this.personaltoken)
            .then(company => {
              this.company = company;
            })
            .catch(error => {
              console.error("EXCEPTION " + error);
              this.dialog.error = true;
            });
        })
        .catch(error => {
          console.error("EXCEPTION " + error);
          this.dialog.error = true;
        });
    },
    copy() {
      this.shipping.name = this.company.name;
      this.shipping.address = this.company.address;
      this.shipping.postalCode = this.company.postalCode;
      this.shipping.city = this.company.city;
      this.shipping.district = this.company.district;
      this.shipping.country = this.company.country;
    },
    checkBeforeSend(isFormValid) {
      this.submitted = true;

      if (!isFormValid) {
        return;
      }

      if(!this.serialNumber) {
        this.dialog.orderConfirm = true;
      } else {
        this.send(isFormValid);
      }
    },
    send(isFormValid) {
      this.submitted = true;
      this.dialog.orderConfirm = false;

      if (!isFormValid) {
        return;
      }

      let data = {
        items: this.cart,
        shippingData: this.shipping,
        personalData: {
          firstName: this.userdata.firstName,
          lastName: this.userdata.lastName,
          email: this.userdata.email,
          company: this.company
        },
        priority: this.priority,
        orderType: this.orderType,
        serialNumber: this.serialNumber,
        comment: this.comment,
        totalPrice: this.totalPrice || null,
        currency: this.cart[0]?.currency || null
      }

      this.afterSalesService.postSpOrders(this.personaltoken, data)
        .then((data) => {
          if (data.code === "200") {
            this.dialog.success = true;
            setTimeout(() => {
              this.$store.commit('afterSales/cart', []);
            }, 3000);
          } else {
            this.dialog.error = true;
            console.error(JSON.stringify(data));
          }
        })
        .catch(error => {
          this.dialog.error = true;
          console.error("ERROR " + error);
        });

    }
  }
}
</script>

<style scoped></style>